import React, { useEffect, useState } from "react";
import ItemService from "../../../../services/supplier_appCommonService";

const ShowUploadImage = ({ fileid }) => {
  const [getFiles, setFiles] = useState();
  useEffect(() => {
    const loadUploadedFiles = async (attachmentId) => {
      if (attachmentId) {
        let obj = {
          attachmentId,
        };
        // setStatus(true);
        await ItemService.getUploadedFiles(obj).then((item) => {
          setFiles(item?.data[item.data.length - 1]?.Location);
        });
        // setStatus(false);
      } else {
        // alert('Please select a file first.');
      }
    };
    loadUploadedFiles(fileid);
  }, [fileid]);

  if (!fileid) {
    return <p>No image available</p>;
  }

  return (
    <div className="text-center m-2">
      <img
        src={getFiles}
        alt="material_image"
        className="max-w-full h-auto rounded-lg shadow-md transition-transform duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(59,130,246,0.8)]"
      />
    </div>
  );
};

export default ShowUploadImage;
